import React from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';

function ErrorBoundary({ children }: React.PropsWithChildren<{}>) {
  return (
    <ReactErrorBoundary
      FallbackComponent={() => <div>Something went wrong</div>}
    >
      {children}
    </ReactErrorBoundary>
  );
}

export default ErrorBoundary;
